import { render, staticRenderFns } from "./EPIList.vue?vue&type=template&id=e2d59068&scoped=true"
import script from "./EPIList.vue?vue&type=script&lang=js"
export * from "./EPIList.vue?vue&type=script&lang=js"
import style0 from "./EPIList.vue?vue&type=style&index=0&id=e2d59068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d59068",
  null
  
)

export default component.exports